import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';

@Component({
  selector: 'app-confirm-indentify',
  templateUrl: './confirm-indentify.component.html'
})
export class ConfirmIndentifyComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmIndentifyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public message: Message,
    public commonService: CommonService,
    public dialog: MatDialog,
    private router: Router,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onClickBtnViewUpdate(){
    const id = localStorage.getItem('enterpriseId')
    this.router.navigate(['/home-enterprise/update-enterprise/'], {
      queryParams: {
        tenantId: localStorage.getItem('tenantId'),
        // page: this.paginate.currentPage,
        // pageSize: this.paginate.pageSize,
        enterpriseId: id,
        // taxCode: this.oldData.taxCode,
        // keyword: this.oldData.keyword,
        // status: status.toString(),
        // types: types.toString(),
      }
      
    });
    this.dialogRef.close()
  }

  onKyc() {
    const message = this.commonService.format(this.message.getMessage('messages.ekyc_must_be_on_phone_after_update'))
    const dialogRe = this.dialog.open(AlertEkycComponent, {
      width: '600px',
      data: message,
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        console.log("close")
      }
    });
    this.dialogRef.close()
  }


}
